import React from "react";
import styles from "./InfoSectionErrorText.module.scss";

export default function InfoSectionErrorText({ visible, text, subtext }) {
    if (visible === false) return null;

    return (
        <>
            {text || subtext ? (
                <div className={styles.container}>
                    {text}
                    {subtext && <div className={styles.subContainer}>{subtext}</div>}
                </div>
            ) : null}
        </>
    );
}
